import React from 'react'
import DefaultHero from './default'
import DefaultHero2 from './default2'
import DesdeTuCelular from './DesdeTuCelular'
import TeLaLlevamos from './TeLaLlevamos'
import AhoraPodesDecidir from './ahora-podes-decidir'
import WhatsApp from './whatsapp'
import Preaprobadas from './preaprobadas'
import CreditoHero from './credito-hero'
import Planillas from './planillas'
import Bac360Hero from './bac360-hero'
import CashAdvance from './cash-advance'
import BacObjetivos from './bac-objetivos'
import MillasPlus from './millasplus-hero'
import AmericanExpress from './american-express'
import AmericanExpressSeguros from './american-express-seguros'
import AmericanExpressTarjetas from './american-express-tarjetas'
import Marchamo from './marchamo'
import CuentasAhorro from './cuentas-ahorro'
import Ahorros from './ahorros'
import ChuzoWeek from './chuzo-week'
import MillasPlusSalas from './millas-plus-salas'
import FastTrack from './fast-track'
const Heros = {
  default: DefaultHero,
  desdeTuCelular: DesdeTuCelular,
  TeLaLlevamos: TeLaLlevamos,
  'ahora-podes-decidir': AhoraPodesDecidir,
  whatsapp: WhatsApp,
  preaprobadas: Preaprobadas,
  default2: DefaultHero2,
  creditoHero: CreditoHero,
  planillas: Planillas,
  bac360Hero: Bac360Hero,
  cashAdvance: CashAdvance,
  bacObjetivos: BacObjetivos,
  millasPlus: MillasPlus,
  americanExpress: AmericanExpress,
  americanExpressSeguros: AmericanExpressSeguros,
  americanExpressTarjetas: AmericanExpressTarjetas,
  marchamo: Marchamo,
  cuentasAhorro: CuentasAhorro,
  ahorros: Ahorros,
  chuzoWeek: ChuzoWeek,
  millasPlusSalas: MillasPlusSalas,
  fastTrack: FastTrack,
}

export default props => {
  const Hero = Heros[props.hero]

  return (
    <div>
      <Hero {...props} />
    </div>
  )
}
